import React, { useRef, useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import data from "../language.json";

function OtpVerify() {
  const inputRefs = useRef([]);
  const { lang, phone, setAlert, setMessage, setPhone } = useContext(languageContext);
  const [Otp, setOtp] = useState(new Array(4).fill(""));
  const [counter, setCounter] = useState(300); // 5-minute timer
  const navigate = useNavigate();
  const location = useLocation();
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const { from } = location.state || {};

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    const updatedOtp = [...Otp];
    updatedOtp[index] = element.value;
    setOtp(updatedOtp);

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !Otp[index]) {
      const newotp = [...Otp];
      newotp[index - 1] = "";
      inputRefs.current[index - 1].focus();
      setOtp(newotp);
    }
  };

  useEffect(() => {
    if (counter > 0) {
      const timer = setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const verifyOtp = async () => {
    const otpValue = Otp.join("");

    if (otpValue.length !== 4) {
      setAlert(true);
      setMessage("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setVerifyingOtp(true);

      const response = await axios.post(
        "https://www.careplus.gopillz.com/warden_login",
        {
          phone: phone,
          otp: otpValue,
        },
        {
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.access_token || response.status === 200) {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("login", true);
        setPhone("");
        if (from === "warden-login") {
          navigate("/warden-dashboard");
        } else {
          navigate("/warden-login");
        }
      } else {
        setAlert(true);
        setMessage(response.data.msg || "OTP verification failed. Please try again.");
      }
    } catch (error) {
      setAlert(true);
      setMessage(error.response?.data?.msg || "OTP verification failed. Please try again.");
    } finally {
      setVerifyingOtp(false);
    }
  };

  return (
    <div className="bg-[#f9fafb] min-h-screen">
      <Navbar />
      <div className="flex flex-col items-center justify-center px-6 py-10 min-h-[calc(100vh-100px)]">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800">
            {data[lang]["auth"][2] || "Verify OTP"}
          </h2>
          <p className="text-center text-gray-600 mt-2">
            Enter the 4-digit code sent to your registered warden phone number.
          </p>

          <div className="flex justify-center gap-3 mt-6">
            {Otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                value={digit}
                ref={(ref) => (inputRefs.current[index] = ref)}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-12 h-12 rounded-lg text-center text-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            ))}
          </div>

          <button
            onClick={verifyOtp}
            disabled={verifyingOtp}
            className={`w-full mt-6 py-2 rounded-lg text-white font-semibold transition ${
              verifyingOtp ? "bg-blue-300 cursor-not-allowed" : "bg-bluebtn hover:bg-blue-700"
            }`}
          >
            {verifyingOtp ? (
              <div className="animate-spin h-5 w-5 border-t-2 border-white mx-auto rounded-full border-solid"></div>
            ) : (
              "Verify OTP"
            )}
          </button>

          <div className="mt-4 text-center text-gray-600">
            {counter > 0 ? (
              <p>Resend OTP in <span className="font-medium text-gray-800">{formatTime(counter)}</span></p>
            ) : (
              <button
                onClick={() => setCounter(300)}
                className="text-blue-500 hover:underline font-medium"
              >
                Resend OTP
              </button>
            )}
          </div>

          <div className="mt-6 text-center">
            <a href="/warden-login" className="text-sm text-blue-500 hover:underline">
              Back to Warden Login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtpVerify;
